import Repository from "./Repository";

const chapters = "/chapters";

export default {
  get: (theme) => Repository.get(`${chapters}/?theme=${theme}`),
  getSubchapters: (chapterId) =>
    Repository.get(`${chapters}/${chapterId}/subchapters/`),
};
